module.exports = __webpack_public_path__ + "img/clinic-image3.273fe66.jpg";